"use strict";
import "src/decidim/meetings/meetings_form";
import "src/decidim/meetings/meetings_polls";
import "src/decidim/forms/forms";
require.context("../images", true);
import "stylesheets/decidim/meetings/meetings.scss";
